import { EnumBase } from 'hay-core-react';
class PlanoTipoPlanoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.plano.tipoplano.padrao',
                { chave: 'main.plano.tipoplano.radius', desabilitado: true },
            ],
            'main.plano.tipoplano.padrao'
        );
    }
}

const instance = new PlanoTipoPlanoEnum();
export default instance;
